module.exports = __webpack_public_path__ + "img/main-logo.d0a5ea41.png";